import { Stack, Typography, useTheme } from "@mui/material";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { FC, ReactNode } from "react";

type Props = {
  title: string;
  subtitle?: string;
  onClick: () => void;
  children: ReactNode;
};

export const Tile: FC<Props> = ({ title, subtitle, onClick, children }) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      gap={Spacing.L}
      sx={{
        border: `1px solid ${theme.colors.borderLight}`,
        borderRadius: theme.spacing(Radius.M),
        padding: theme.spacing(Spacing.L),
        boxShadow: theme.shadows[1],
        background: theme.colors.white,
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <Stack spacing={Spacing.M} width="100%" direction="column" justifyContent="flex-start" mt={theme.spacing(Spacing.XS)}>
        <Stack spacing={Spacing.XS}>
          <Typography variant="body2" color={theme.colors.textPrimary} fontWeight={600}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="caption" color={theme.colors.textSecondary} fontWeight={400}>
              {subtitle}
            </Typography>
          )}
        </Stack>

        {children}
      </Stack>
    </Stack>
  );
};
